module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar categoryID, category, categoryDataID, categoryData;\nvar disabled = false;\nif(!!formMapping && !!formMapping.fieldConfig) {\ndisabled = !!formMapping.fieldConfig.disabled;\n}\nvar text;\nif((model.config || {}).useLabelInButton){\ntext = model.label;\n}\nif(text && (model.config || {}).showNrOfChoosenTagsInButton) {\nvar nrOfChoosenTags = 0;\nfor(categoryID in model.summaryOfAssignedCategories || {}){\nfor(categoryDataID in (model.summaryOfAssignedCategories[categoryID] || {}).children || {}){\nif(model.summaryOfAssignedCategories[categoryID].children[categoryDataID].type !== 'delete'){\nnrOfChoosenTags++;\n}\n}\n}\nif(nrOfChoosenTags > 0){\ntext += ' (' + nrOfChoosenTags + ')'\n}\n}\nvar additionalClasses = [];\nif(disabled) \t\t\t\t\t\tadditionalClasses.push('disabled');\nif((model.config || {}).isHidden) \tadditionalClasses.push('isHidden');\nvar buttonType = 'assign';\nif((model.config || {}).buttonType) buttonType = model.config.buttonType;\nvar buttonContext = 'tags';\nif((model.config || {}).buttonContext) buttonContext = model.config.buttonContext;\nvar buttonText;\nif((model.config || {}).buttonText) buttonText = model.config.buttonText;\nif((model.config || {}).style) additionalClasses.push(model.config.style);\n%>\n<div class=\"<%- (additionalClasses.join(' ')) %>\" data-field-code=\"<%= model.fieldCode %>\">\n<section class=\"top\">\n<%\nif((model.config || {}).additionalTopTitle) {\n%><div class=\"topTitle\"><%= __(model.config.additionalTopTitle) %></div><%\n}\n%>\n<%- include('../elements/buttons/default', { formMapping: { buttonType: buttonType, context: buttonContext, buttonText: buttonText, title: text, positive: model.config.buttonPositive, negative: model.config.buttonNegative } }); %>\n<%\nif((model.config || {}).tagConnectionChoosable){\nvar tagConnectionFieldCode = (model.fieldCode || '') + '_tagConnection';\nvar tagConnectionFieldValue;\nif(((model.dirtySubFields || {})[tagConnectionFieldCode]) !== undefined){\ntagConnectionFieldValue = ((model.dirtySubFields || {})[tagConnectionFieldCode])\n} else if(((model.additionalAttributes || {})[tagConnectionFieldCode]) !== undefined){\ntagConnectionFieldValue = ((model.additionalAttributes || {})[tagConnectionFieldCode])\n}\nvar tagConnectionData = {\nmodel: {\nfieldCode: tagConnectionFieldCode,\ndata: [\n{ name: __('button:tagConnection.and'), value: 'AND' },\n{ name: __('button:tagConnection.or'), value: 'OR', defaultSelected: true }\n],\nvalue: tagConnectionFieldValue\n},\nformMapping: {}\n}\n%>\n<%- include('./toggle', tagConnectionData); %>\n<%\n}\nif((model.config || {}).supportDeleteSelection){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: buttonType, context: buttonContext, mode: 'empty', symbolOnly: true } }); %><%\n}\n%>\n</section>\n<%\nif((model.config || {}).showSummary && model.summaryOfAssignedCategories) {\n%>\n<div class=\"tags\">\n<%\nfor(categoryID in model.summaryOfAssignedCategories || {}){\ncategory = model.summaryOfAssignedCategories[categoryID] || {};\n%>\n<div class=\"category<%= category.showHiddenCategory ? ' isShownHidden' : '' %>\">\n<%\nif((model.config || {}).showCategoriesInSummary !== false){\n%><%= category.name %><%\n}\n%>\n<div class=\"children\">\n<%\nfor(categoryDataID in category.children || {}){\ncategoryData = category.children[categoryDataID] || {};\n%><div class=\"categoryData type_<%- categoryData.type %>\"><%\nif((model.config ||{}).showSummaryFullPaths){\n%><%= categoryData.names.join(' / ') %><%\n} else {\n%><%= categoryData.name %><%\n}\n%></div><%\n}\n%>\n</div>\n</div>\n<%\n}\n%>\n</div>\n<%\n}\n%>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/form/fields/tag-picker-button.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var categoryID, category, categoryDataID, categoryData;
var disabled = false;
if(!!formMapping && !!formMapping.fieldConfig) {
disabled = !!formMapping.fieldConfig.disabled;
}
var text;
if((model.config || {}).useLabelInButton){
text = model.label;
}
if(text && (model.config || {}).showNrOfChoosenTagsInButton) {
var nrOfChoosenTags = 0;
for(categoryID in model.summaryOfAssignedCategories || {}){
for(categoryDataID in (model.summaryOfAssignedCategories[categoryID] || {}).children || {}){
if(model.summaryOfAssignedCategories[categoryID].children[categoryDataID].type !== 'delete'){
nrOfChoosenTags++;
}
}
}
if(nrOfChoosenTags > 0){
text += ' (' + nrOfChoosenTags + ')'
}
}
var additionalClasses = [];
if(disabled) 						additionalClasses.push('disabled');
if((model.config || {}).isHidden) 	additionalClasses.push('isHidden');
var buttonType = 'assign';
if((model.config || {}).buttonType) buttonType = model.config.buttonType;
var buttonContext = 'tags';
if((model.config || {}).buttonContext) buttonContext = model.config.buttonContext;
var buttonText;
if((model.config || {}).buttonText) buttonText = model.config.buttonText;
if((model.config || {}).style) additionalClasses.push(model.config.style);

    ; __line = 34
    ; __append("\n<div class=\"")
    ; __line = 35
    ; __append( (additionalClasses.join(' ')) )
    ; __append("\" data-field-code=\"")
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\">\n<section class=\"top\">\n")
    ; __line = 37
    ; 
if((model.config || {}).additionalTopTitle) {

    ; __line = 39
    ; __append("<div class=\"topTitle\">")
    ; __append(escapeFn( __(model.config.additionalTopTitle) ))
    ; __append("</div>")
    ; 
}

    ; __line = 41
    ; __append("\n")
    ; __line = 42
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: buttonType, context: buttonContext, buttonText: buttonText, title: text, positive: model.config.buttonPositive, negative: model.config.buttonNegative } }) )
    ; __append("\n")
    ; __line = 43
    ; 
if((model.config || {}).tagConnectionChoosable){
var tagConnectionFieldCode = (model.fieldCode || '') + '_tagConnection';
var tagConnectionFieldValue;
if(((model.dirtySubFields || {})[tagConnectionFieldCode]) !== undefined){
tagConnectionFieldValue = ((model.dirtySubFields || {})[tagConnectionFieldCode])
} else if(((model.additionalAttributes || {})[tagConnectionFieldCode]) !== undefined){
tagConnectionFieldValue = ((model.additionalAttributes || {})[tagConnectionFieldCode])
}
var tagConnectionData = {
model: {
fieldCode: tagConnectionFieldCode,
data: [
{ name: __('button:tagConnection.and'), value: 'AND' },
{ name: __('button:tagConnection.or'), value: 'OR', defaultSelected: true }
],
value: tagConnectionFieldValue
},
formMapping: {}
}

    ; __line = 63
    ; __append("\n")
    ; __line = 64
    ; __append( include('./toggle', tagConnectionData) )
    ; __append("\n")
    ; __line = 65
    ; 
}
if((model.config || {}).supportDeleteSelection){

    ; __line = 68
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: buttonType, context: buttonContext, mode: 'empty', symbolOnly: true } }) )
    ; 
}

    ; __line = 70
    ; __append("\n</section>\n")
    ; __line = 72
    ; 
if((model.config || {}).showSummary && model.summaryOfAssignedCategories) {

    ; __line = 74
    ; __append("\n<div class=\"tags\">\n")
    ; __line = 76
    ; 
for(categoryID in model.summaryOfAssignedCategories || {}){
category = model.summaryOfAssignedCategories[categoryID] || {};

    ; __line = 79
    ; __append("\n<div class=\"category")
    ; __line = 80
    ; __append(escapeFn( category.showHiddenCategory ? ' isShownHidden' : '' ))
    ; __append("\">\n")
    ; __line = 81
    ; 
if((model.config || {}).showCategoriesInSummary !== false){

    ; __line = 83
    ; __append(escapeFn( category.name ))
    ; 
}

    ; __line = 85
    ; __append("\n<div class=\"children\">\n")
    ; __line = 87
    ; 
for(categoryDataID in category.children || {}){
categoryData = category.children[categoryDataID] || {};

    ; __line = 90
    ; __append("<div class=\"categoryData type_")
    ; __append( categoryData.type )
    ; __append("\">")
    ; 
if((model.config ||{}).showSummaryFullPaths){

    ; __line = 92
    ; __append(escapeFn( categoryData.names.join(' / ') ))
    ; 
} else {

    ; __line = 94
    ; __append(escapeFn( categoryData.name ))
    ; 
}

    ; __line = 96
    ; __append("</div>")
    ; 
}

    ; __line = 98
    ; __append("\n</div>\n</div>\n")
    ; __line = 101
    ; 
}

    ; __line = 103
    ; __append("\n</div>\n")
    ; __line = 105
    ; 
}

    ; __line = 107
    ; __append("\n</div>")
    ; __line = 108
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/form/fields/tag-picker-button.ejs

}